// modules
import React, { Fragment } from 'react';

// local
import './Logo.css';


const Logo = () =>  (
  <Fragment>
    <img className={ 'Logo__title' } src={ '/_img/momentum-logo.svg' } alt={ 'logo' } />
    <h3 className={ 'Logo__subtitle' }>{ 'Plan better trades.' }</h3>
  </Fragment>
);

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo/index.js